import React from "react";
import Button from "./Button";
import Card from "./Card";
import { colors, spacing } from "./theme";

export default function EmptyState({
  icon = "📭",
  title = "No data found",
  message = "There is nothing to display yet.",
  actionLabel,
  onAction,
  style = {}
}) {
  return (
    <Card
      style={{
        textAlign: "center",
        padding: spacing["2xl"],
        ...style
      }}
    >
      <div style={iconStyle}>{icon}</div>

      <h3 style={titleStyle}>{title}</h3>

      <p style={messageStyle}>{message}</p>

      {actionLabel && onAction && (
        <Button onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Card>
  );
}

const iconStyle = {
  fontSize: 38,
  marginBottom: spacing.md
};

const titleStyle = {
  margin: 0,
  color: colors.text,
  fontSize: 20,
  fontWeight: 800
};

const messageStyle = {
  margin: "8px auto 18px",
  color: colors.textMuted,
  maxWidth: 520,
  lineHeight: 1.6
};